__turbopack_context__.v({
  "background": "LocationBlock-module__1uO-ua__background",
  "container": "LocationBlock-module__1uO-ua__container",
  "container__content": "LocationBlock-module__1uO-ua__container__content",
  "container__content__map_container": "LocationBlock-module__1uO-ua__container__content__map_container",
  "container__content__ubication": "LocationBlock-module__1uO-ua__container__content__ubication",
});
